import { I18nComponente } from "@/types/gerais"

export const OCaracteristicaValorListai18n: I18nComponente = {
  "pt-BR": {
    atributo: "atributo",
    removerCaracteristica: "remover característica",
    adicionarCaracteristica: "adicionar característica",
    duplicado: "Duplicado",
    caracteristicaJaFoiAdicionada: "A característica já foi adicionada",
  },
  "es-CO": {
    atributo: "atributo",
    removerCaracteristica: "borrar característica",
    adicionarCaracteristica: "agregar característica",
    duplicado: "Duplicado",
    caracteristicaJaFoiAdicionada: "La característica ya ha sido agregada",
  },
}
